import { Domain } from "../../schema/types/domain/entity";
import { linksOf } from "../../services/cpln";
import { isApex, nameOfDomainStatus } from "../../services/utils";
import { parseLink } from "../../utils/linkParser/linkParser";

export const domainHelpers = {
  getIsApex(domain: Domain) {
    return isApex(domain.name);
  },
  getDomainStatusText(domain: Domain): string {
    return nameOfDomainStatus(domain.status as any);
  },
  getType(domain: Domain): string {
    let result = domain.spec.dnsMode.toUpperCase();
    return result;
  },
  getMappedGVC(domain: Domain) {
    let result = "";
    if (domain.spec?.gvcLink) {
      result = domain.spec?.gvcLink.split("/gvc/")[1];
    } else if ((domain.spec?.ports || []).some((p) => (p.routes || []).length > 0)) {
      const port = (domain.spec?.ports || []).find((p) => (p.routes || []).length > 0);
      if (port) {
        const workloadLink = (port.routes || [])[0].workloadLink;
        result = workloadLink?.split("/gvc/")[1].split("/workload/")[0]!;
      }
    }
    return result;
  },
  getEndpointCount(domain: Domain) {
    return (domain.status?.endpoints || []).length;
  },
};

export interface DomainTableItem extends Domain {
  selfLink: string;
  domainStatusText: string;
  type: string;
  mappedGVC: string;
  endpointCount: number;
}

interface GetDomainTableItemProps {
  link?: string;
  name?: string;
  item?: Domain;
}
export function getDomainTableItem({ link, name, item }: GetDomainTableItemProps): DomainTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;
    const domainStatusText = domainHelpers.getDomainStatusText(item);
    const type = domainHelpers.getType(item);
    const mappedGVC = domainHelpers.getMappedGVC(item);
    const endpointCount = domainHelpers.getEndpointCount(item);

    return {
      ...item,
      selfLink: selfLink,
      domainStatusText: domainStatusText,
      type: type,
      mappedGVC: mappedGVC,
      endpointCount: endpointCount,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "domain",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      domainStatusText: "",
      endpointCount: 0,
      mappedGVC: "",
      spec: {
        acceptAllHosts: false,
        acceptAllSubdomains: false,
        certChallengeType: "http01",
        dnsMode: "cname",
        ports: [],
      },
      type: "",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "domain",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    domainStatusText: "",
    endpointCount: 0,
    mappedGVC: "",
    spec: {
      acceptAllHosts: false,
      acceptAllSubdomains: false,
      certChallengeType: "http01",
      dnsMode: "cname",
      ports: [],
    },
    type: "",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
